var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble2Teal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.274,
    height: 167.178,
    viewBox: "0 0 162.274 167.178",
    fill: "#008996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 162.274,
    height: 167.178,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M147.033,119.719c26.379-32.18,16.99-80.686-16.392-104.84C96.284-9.982,44.314-2.856,17.726,30.033c-27.447,33.954-22.4,88.274,10.852,116.527,25.839,21.953,94.486,35.112,109-6.73,1.358-3.917-2.288-8.919-6.514-8.55-11.667,1.017-20.245,6.73-31.392,9.688-15.28,4.055-33.141,2.679-47.358-4.4-31.574-15.714-40.6-59.354-22.8-88.56,17.662-28.978,59.958-37.825,88.528-20.165,30.029,18.563,36.834,59.5,28.055,91.324-.142.51.57,1,.941.548",
    transform: "translate(0 -0.001)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble2Teal);
export default __webpack_public_path__ + "static/media/bubble-2-teal.33ed2c2da63225b1af0e62a508e5ebaa.svg";
export { ForwardRef as ReactComponent };